export default __webpack_public_path__ + "static/media/ap logo main white.4eb70e48.png";